/**
 * ======================================================
 * IMPORTANT
 * ---------
 * This file is ONLY meant to import and export the images and assets in order to be processed by Vite.
 * If you feel the need to declare a variable/constant in relation with an import here, then
 * it either belongs on a specific "feature file" or if it's meant to be a global constant
 * then it should live in `app_constants.js`.
 * ======================================================
 */

import IMAGE_ACCESS_DENIED from '../assets/images/illustrations/access_denied.svg';
import IMAGE_NO_REPORT_DATA from '../assets/images/illustrations/no_report_data.png';
import IMAGE_NO_SITES from '../assets/images/illustrations/gps.svg';
import IMAGE_NO_ACTIVITY from '../assets/images/activities/no-activity.svg';

import IMAGE_INTEGRATION_PROJECTS from '../assets/images/wizard/projects-and-users.svg';
import IMAGE_PASSWORD_CREATED from '../assets/images/illustrations/invite-copy-password.svg';
import IMAGE_WORK_ORDERS_MAP from '../assets/images/illustrations/work-orders-map.svg';
import IMAGE_WORK_ORDERS_SCHEDULE_JOB from '../assets/images/illustrations/work-orders-schedule-job.svg';
import IMAGE_WORK_ORDERS_BUDGET from '../assets/images/illustrations/work-orders-budget.svg';
import IMAGE_SET_UP_THE_SUCCESS from '../assets/images/illustrations/set-up-the-success.svg';
import ICON_MARKER_START from '../assets/images/global/marker-start.png';
import ICON_MARKER_MOVE from '../assets/images/global/marker-move.png';
import ICON_MARKER_SITE from '../assets/images/global/marker-site.png';
import ICON_MARKER_WHITE from '../assets/images/global/marker-site-white.svg';
import ICON_MARKER_CURRENT_LOCATION from '../assets/images/global/marker-current-location.png';
import ICON_GEOLOCATION from '../assets/images/global/geolocation-icon.svg';
import ICON_PLUS from '../assets/images/global/plus-icon.svg';
import ICON_CONNECT from '../assets/images/global/connect-icon.svg';
import ICON_DISCONNECT from '../assets/images/global/disconnect-icon.svg';
import ICON_ARROW_GREEN from '../assets/images/global/arrow_green.svg';
import ICON_ARROW_RED from '../assets/images/global/arrow_red.svg';
import ICON_TRIANGLE_ROUNDED from '../assets/images/global/triangle-rounded.svg';
import ICON_GEARS from '../assets/images/global/gears.svg';
import HUBSTAFF_PEOPLE_BETA from '../assets/images/global/hubstaff-people-beta.svg';
import HUBSTAFF_PEOPLE_BETA_TRANSPARENT from '../assets/images/global/hubstaff-people-beta-transparent.svg';
import HUBSTAFF_LOGO from '../assets/images/global/hubstaff-icon-128.png';
import INTEGRATIONS_HERO_WISE from '../assets/images/illustrations/integrations_hero_wise.png';
import TRANSFERWISE_LOGO from '../assets/images/payroll/transferwise.svg';
import RECEIPT_ICON from '../assets/images/expenses/receipt.svg';
import NOTHING_HERE from '../assets/images/nothing_here.svg';
import IMAGE_WORK_ORDER from '../assets/images/work_orders/work_order.svg';
import IMAGE_NO_WORK_BREAK_POLICIES from '../assets/images/work_breaks/work_break_policies_empty_state.svg';
import WINDOWS_LOGO from '../assets/images/downloads/microsoft-blue.svg';
import MACOS_LOGO from '../assets/images/downloads/apple-blue.svg';
import LINUX_LOGO from '../assets/images/downloads/linux-blue.svg';
import ICON_SHIELD from '../assets/images/global/shield.svg';
import ICON_SHIELD_WARNING from '../assets/images/global/shield_warning.svg';
import IMAGE_EMPTY_BOX from '../assets/images/empty_box.svg';

import BADGE_CHECK from '../assets/images/global/badge-check.svg';
import IMAGE_HS_TASKS_LOGO from '../assets/images/global/hubstaff-tasks-logo.svg';
import ACTIVITIES_SIDEBAR_NO_GPS from '../assets/images/activities/GPS_HS.svg';

import ACTIVITIES_SCREENSHOT_PENDING_ORIGINAL from '../assets/images/activities/screenshot_pending_original.png';
import IMAGE_NO_DATA_PLACEHOLDER from '../assets/images/illustrations/looking.svg';
import IMAGE_EMPTY_PLAYLIST from '../assets/images/illustrations/empty_playlist.svg';
import IMAGE_NO_OVERTIME_POLICIES from '../assets/images/overtime_policies/ot_policies_empty_state.svg';

import HS_TIMER_APPLE from '../assets/images/downloads/osx.svg';
import HS_TIMER_LINUX from '../assets/images/downloads/linux-color.svg';
import HS_TIMER_CHROME from '../assets/images/downloads/chromeapp-color.svg';
import HS_TIMER_ANDROID from '../assets/images/downloads/android-color.svg';
import HS_TIMER_WINDOWS from '../assets/images/downloads/windows-color.svg';
import HS_TIMER_WEB_TIMER from '../assets/images/downloads/web-timer.svg';

import EMPTY_FOLDER_ILLUSTRATION from '../assets/images/illustrations/empty-folder-alt.svg';

import ACTIVITIES_VIEW_ROUTE_ACTIVE from '../assets/images/activities/avatar-side-markers/view-route-active.svg';
import ACTIVITIES_VIEW_ROUTE_INACTIVE from '../assets/images/activities/avatar-side-markers/view-route-inactive.svg';
import ACTIVITIES_VIEW_INFO_ACTIVE from '../assets/images/activities/avatar-side-markers/view-info-active.svg';
import ACTIVITIES_VIEW_INFO_INACTIVE from '../assets/images/activities/avatar-side-markers/view-info-inactive.svg';
import ACTIVITIES_SMART_NOTIFICATIONS_BANNER_ILLUSTRATION from '../assets/images/activities/smart_notifications_banner.svg';

import ACHIEVEMENT_BADGE_EFFICIENCY_PRO from '../assets/images/achievements/efficiency_pro.svg';
import ACHIEVEMENT_BADGE_TIME_HERO from '../assets/images/achievements/time_hero.svg';
import ACHIEVEMENT_BADGE_PRODUCTIVITY_CHAMP from '../assets/images/achievements/productivity_champ.svg';

import ACTIVITIES_INSIGHTS_DONUT_CHART_PLACEHOLDER from '../assets/images/activities/insights-placeholders/donut_chart_placeholder.png';
import ACTIVITIES_INSIGHTS_PIE_CHART_PLACEHOLDER from '../assets/images/activities/insights-placeholders/pie_chart_placeholder.png';


import INSIGHTS_LOGO from '../assets/images/insights/logo.svg';

import INSIGHTS_BANNER_UPGRADE from '../assets/images/insights/insights_banner_upgrade.svg';
import INSIGHTS_BANNER_ENABLE from '../assets/images/insights/insights_banner_enable.svg';
import INSIGHTS_BANNER_WORKFORCE from '../assets/images/insights/insights_banner_workforce.svg';
import INSIGHTS_BANNER_SUSPICIOUS_BEHAVIOR from '../assets/images/insights/insights_banner_suspicious_behavior.svg';
import INSIGHTS_BANNER_UNUSUAL_ACTIVITY from '../assets/images/insights/insights_banner_unusual_activity.svg';
import NO_INSIGHTS_UA_BLUR_USER_1 from '../assets/images/mailer/no_insights_ua/blur_user_1.png';
import NO_INSIGHTS_UA_BLUR_USER_2 from '../assets/images/mailer/no_insights_ua/blur_user_2.png';
import NO_INSIGHTS_UA_BLUR_USER_3 from '../assets/images/mailer/no_insights_ua/blur_user_3.png';
import NO_INSIGHTS_UA_BLUR_USER_4 from '../assets/images/mailer/no_insights_ua/blur_user_4.png';
import NO_INSIGHTS_UA_BLUR_USER_5 from '../assets/images/mailer/no_insights_ua/blur_user_5.png';
import NO_INSIGHTS_UA_TIME_BLUR from '../assets/images/mailer/no_insights_ua/time_blur.png';
import INSIGHTS_BANNER_DIALOG_WTE from '../assets/images/insights/insights_banner_dialog_WTE.png';
import INSIGHTS_BANNER_DIALOG__APP_URLS from '../assets/images/insights/insights_banner_dialog_app_urls.png';
import INSIGHTS_BANNER_DIALOG_HIGHLIGHTS from '../assets/images/insights/insights_banner_dialog_highlights.png';
import INSIGHTS_BANNER_DIALOG_FOCUS_TIME from '../assets/images/insights/insights_banner_dialog_focus_time.png';

import INSIGHTS_RANKING_BLURRED_ITEMS_4 from '../assets/images/insights/placeholders/insights_ranking_blurred_items_4.svg';
import INSIGHTS_RANKING_BLURRED_ITEMS_5 from '../assets/images/insights/placeholders/insights_ranking_blurred_items_5.svg';
import INSIGHTS_RANKING_BLURRED_ITEMS_10 from '../assets/images/insights/placeholders/insights_ranking_blurred_items_10.svg';

import INSIGHTS_TIMELINE_BLURRED_APPS_URLS from '../assets/images/insights/placeholders/insights_timeline_blurred_apps_urls.svg';

import INSIGHTS_ACTIVITY_TRACKING_DISABLED from '../assets/images/insights/empty_states/activity_tracking_disabled.svg';
import INSIGHTS_TOOLS_TRACKING_DISABLED from '../assets/images/insights/empty_states/tools_tracking_disabled.svg';
import INSIGHTS_TOOLS_TRACKING_UNUSED from '../assets/images/insights/empty_states/tools_tracking_unused.svg';
import INSIGHTS_NO_TIME_TRACKED from '../assets/images/insights/no_time_tracked.svg';

import INSIGHTS_INTEGRATION_UNAUTHORIZED from '../assets/images/insights/integration_unauthorized.svg';
import INSIGHTS_GITHUB_INTEGRATION_LOGO from '../assets/images/insights/gitHubIntegrationLogo.svg';

import INSIGHTS_OUTPUT_NO_DATA from '../assets/images/insights/insights_output_no_data.png';
import INSIGHTS_UNUSUAL_ACTIVITIES_BLURRED_APPS from '../assets/images/insights/placeholders/unusual_acitivies_blurred_apps.svg';
import INSIGHTS_UNUSUAL_ACTIVITIES_MEMBERS_TABLE_BLUR_LEFT from '../assets/images/insights/placeholders/members_blur_left.jpeg';
import INSIGHTS_UNUSUAL_ACTIVITIES_MEMBERS_TABLE_BLUR_RIGHT from '../assets/images/insights/placeholders/members_blur_right.jpeg';
import INSIGHTS_UNUSUAL_ACTIVITIES_CTA from '../assets/images/insights/cta_unusual_activities.svg';

import INSIGHTS_COLUMN_CHART_PLACEHOLDER from '../assets/images/insights/placeholders/column_chart_placeholder.svg';
import INSIGHTS_DONUT_CHART_PLACEHOLDER from '../assets/images/insights/placeholders/donut_chart_placeholder.svg';
import INSIGHTS_SHORT_PARAGRAPH_PLACEHOLDER from '../assets/images/insights/placeholders/short_paragraph_placeholder.svg';

import INSIGHTS_MEETINGS_DIALOG_ILLUSTRATION from '../assets/images/insights/meetings_dialog_illustration.png';
import INSIGHTS_MEETINGS_CONNECT from '../assets/images/insights/meetings_connect.svg';
import INSIGHTS_MEETINGS_GOOGLE_LOGO from '../assets/images/insights/google_signin_light.svg';
import INSIGHTS_MEETINGS_MICROSOFT365_LOGO from '../assets/images/insights/ms365.svg';

import INSIGHTS_CANCELLATION_BANNER_ILLUSTRATION_RED from '../assets/images/insights/cancellation_flow/banner_illustration_red.svg';
import INSIGHTS_CANCELLATION_BANNER_ILLUSTRATION_BLUE from '../assets/images/insights/cancellation_flow/banner_illustration_blue.svg';
import INSIGHTS_CANCELLATION_BANNER_ILLUSTRATION_30_DAYS from '../assets/images/insights/cancellation_flow/offer_illustration_30_days.svg';
import INSIGHTS_CANCELLATION_BANNER_ILLUSTRATION_10_PERCENT from '../assets/images/insights/cancellation_flow/offer_illustration_10_percent.svg';

import SETTINGS_SMART_NOTIFICATION_HIGH_ACTIVITY from '../assets/images/settings/smart-notifications-high-activity.svg';
import SETTINGS_SMART_NOTIFICATIONS_UNDERWORKING from '../assets/images/settings/smart-notifications-underworking.svg';
import SETTINGS_SMART_NOTIFICATIONS_LOW_ACTIVITY from '../assets/images/settings/smart-notifications-low-activity.svg';

import SMART_NOTIFICATIONS_LOW_ACTIVITY from '../assets/images/insights/smart_notifications/templates/low_activity.svg';
import SMART_NOTIFICATIONS_LOW_CORE_WORK from '../assets/images/insights/smart_notifications/templates/low_core_work.svg';
import SMART_NOTIFICATIONS_OVERWORKING from '../assets/images/insights/smart_notifications/templates/overworking.svg';
import SMART_NOTIFICATIONS_SUSPICIOUS_APPS from '../assets/images/insights/smart_notifications/templates/suspicious_apps.svg';
import SMART_NOTIFICATIONS_SUSPICIOUSLY_HIGH_ACTIVITY from '../assets/images/insights/smart_notifications/templates/suspiciously_high_activity.svg';
import SMART_NOTIFICATIONS_UNDERWORKING from '../assets/images/insights/smart_notifications/templates/underworking.svg';
import SMART_NOTIFICATIONS_UNPRODUCTIVE_WORK from '../assets/images/insights/smart_notifications/templates/unproductive_work.svg';
import SMART_NOTIFICATIONS_AI_WEBSITES from '../assets/images/insights/smart_notifications/templates/ai_websites.svg';
import SMART_NOTIFICATIONS_ENTERTAINMENT_WEBSITES from '../assets/images/insights/smart_notifications/templates/entertainment_websites.svg';
import SMART_NOTIFICATIONS_NOT_USING_APPS from '../assets/images/insights/smart_notifications/templates/not_using_apps.svg';
import SMART_NOTIFICATIONS_SOCIAL_MEDIA_WEBSITES from '../assets/images/insights/smart_notifications/templates/social_media_websites.svg';
import SMART_NOTIFICATIONS_IDLE_TIME from '../assets/images/insights/smart_notifications/templates/smart-notifications-idle.svg';
import SMART_NOTIFICATIONS_MANUAL_TIME from '../assets/images/insights/smart_notifications/templates/smart-notifications-manual.svg';
import SETTINGS_SMART_NOTIFICATIONS_OVERWORKING from '../assets/images/settings/smart-notifications-overworking.svg';

import ICON_BELL_RINGING from '../assets/images/insights/smart_notifications/sn_bell.svg';

import ICON_WATCH from '../assets/images/global/watch.svg';
import ICON_BELL from '../assets/images/global/bell.svg';

import ICON_ARROW_CONTROL_LEFT from '../assets/images/global/arrow-control-left.svg';
import ICON_ARROW_CONTROL_RIGHT from '../assets/images/global/arrow-control-right.svg';
import ICON_ARROW_CONTROL_LEFT_ROUNDED from '../assets/images/global/arrow-control-left-rounded.svg';
import ICON_ARROW_CONTROL_RIGHT_ROUNDED from '../assets/images/global/arrow-control-right-rounded.svg';

import KEEP_CURRENT_PLAN_ILLUSTRATION from '../assets/images/illustrations/keep-current-plan.svg';

import SCHEDULED_REPORT_BANNER_ILLUSTRATION from '../assets/images/scheduled_reports/banner_illustration.svg';
import TEAMS_PROMOTION_BANNER_ILLUSTRATION from '../assets/images/teams/banner_illustration.svg';
import CONTRACTOR_COMPLIANCE_BANNER_ILLUSTRATION from '../assets/images/contractor_compliance/banner_illustration.svg';

import ORGANIZATION_ARCHIVE_BANNER_ILLUSTRATION_RED from '../assets/images/organization/archive_flow/banner_illustration_red.svg';

import GETTING_STARTED_NO_TEAM_MEMBER_SELECTED from '../assets/images/getting_started/no-team-member-selected.png';
import GETTING_STARTED_TIMESHEET_APPROVED from '../assets/images/getting_started/timesheet-approved.png';
import GETTING_STARTED_FREE_TRIAL_INSIGHTS from '../assets/images/getting_started/free-trial-insights.png';
import GETTING_STARTED_DOWNLOAD_APP_IMG_1 from '../assets/images/getting_started/download-app-img-1.svg';
import GETTING_STARTED_DOWNLOAD_APP_IMG_2 from '../assets/images/getting_started/download-app-img-2.svg';
import GETTING_STARTED_DOWNLOAD_APP_IMG_3 from '../assets/images/getting_started/download-app-img-3.svg';

import INSIGHTS_ONBOARDING_COMPLETED_IMG from '../assets/images/insights_onboarding/completed_illustration.svg';
import INSIGHTS_ONBOARDING_WELCOME_IMG from '../assets/images/insights_onboarding/welcome_illustration.svg';

import VSMB_GETTING_STARTED_IDLE_TIME_ICON from '../assets/images/experiments/0200_vsmb_getting_started/idle_time.svg';
import VSMB_GETTING_STARTED_MANUAL_TIME_ICON from '../assets/images/experiments/0200_vsmb_getting_started/manual_time.svg';
import VSMB_GETTING_STARTED_QUICKSTART_VIDEO_IMG from '../assets/images/experiments/0200_vsmb_getting_started/quickstart_video.png';
import VSMB_GETTING_STARTED_SCREENSHOTS_ICON from '../assets/images/experiments/0200_vsmb_getting_started/screenshots.svg';
import VSMB_GETTING_STARTED_SPEND_TIME_ON_BUSINESS_IMG from '../assets/images/experiments/0200_vsmb_getting_started/spend_time_on_business.png';
import VSMB_GETTING_STARTED_WELCOME_IMG from '../assets/images/experiments/0200_vsmb_getting_started/welcome.png';

// Part of exp 0097 Offer Discount in Cancel Flow for VSMBs
import DISCOUNT_OFFER_ILLUSTRATION from '../assets/images/experiments/0097_offer_discount_in_cancel_flow_for_vsmbs/discount_offer_illustration.png';
import DISCOUNT_ACCEPTED_ILLUSTRATION from '../assets/images/experiments/0097_offer_discount_in_cancel_flow_for_vsmbs/discount_accepted_illustration.png';
// End of exp 0097 Offer Discount in Cancel Flow for VSMBs

export const GETTING_STARTED_SCREENSHOTS = Array.from(
  { length: 25 },
  (_, i) => new URL(`../assets/images/getting_started/screenshots/${i}.jpg`, import.meta.url).href,
);

export const FAKE_DATA_IMAGE_URLS = Array.from({ length: 12 }, (_, i) => ({
  index: i,
  thumb_url: new URL(`../assets/images/samples/shots/${i + 1}_thumb.jpg`, import.meta.url).href,
}));

export const AVATAR_DEFAULT_URL = window.DEFAULT_USER_AVATARS;
export const INTEGRATION_LOGO_URLS = window.INTEGRATION_LOGO_URLS;

export {
  IMAGE_ACCESS_DENIED,
  IMAGE_NO_REPORT_DATA,
  IMAGE_NO_SITES,
  IMAGE_NO_ACTIVITY,
  IMAGE_INTEGRATION_PROJECTS,
  IMAGE_PASSWORD_CREATED,
  IMAGE_WORK_ORDERS_MAP,
  IMAGE_WORK_ORDERS_SCHEDULE_JOB,
  IMAGE_WORK_ORDERS_BUDGET,
  IMAGE_SET_UP_THE_SUCCESS,
  ICON_MARKER_START,
  ICON_MARKER_MOVE,
  ICON_MARKER_SITE,
  ICON_MARKER_WHITE,
  ICON_MARKER_CURRENT_LOCATION,
  ICON_GEOLOCATION,
  ICON_PLUS,
  ICON_CONNECT,
  ICON_DISCONNECT,
  ICON_ARROW_GREEN,
  ICON_ARROW_RED,
  ICON_GEARS,
  ICON_TRIANGLE_ROUNDED,
  ICON_SHIELD,
  ICON_SHIELD_WARNING,
  BADGE_CHECK,
  ICON_BELL_RINGING,
  IMAGE_EMPTY_BOX,
  HUBSTAFF_LOGO,
  RECEIPT_ICON,
  NOTHING_HERE,
  IMAGE_WORK_ORDER,
  IMAGE_NO_WORK_BREAK_POLICIES,
  IMAGE_NO_OVERTIME_POLICIES,
  WINDOWS_LOGO,
  MACOS_LOGO,
  LINUX_LOGO,
  IMAGE_HS_TASKS_LOGO,
  ACTIVITIES_SIDEBAR_NO_GPS,
  ACTIVITIES_SCREENSHOT_PENDING_ORIGINAL,
  ACHIEVEMENT_BADGE_EFFICIENCY_PRO,
  ACHIEVEMENT_BADGE_TIME_HERO,
  ACHIEVEMENT_BADGE_PRODUCTIVITY_CHAMP,
  ACTIVITIES_INSIGHTS_DONUT_CHART_PLACEHOLDER,
  ACTIVITIES_INSIGHTS_PIE_CHART_PLACEHOLDER,
  IMAGE_NO_DATA_PLACEHOLDER,
  IMAGE_EMPTY_PLAYLIST,
  HS_TIMER_APPLE,
  HS_TIMER_LINUX,
  HS_TIMER_CHROME,
  HS_TIMER_ANDROID,
  HS_TIMER_WINDOWS,
  HS_TIMER_WEB_TIMER,
  EMPTY_FOLDER_ILLUSTRATION,
  HUBSTAFF_PEOPLE_BETA,
  INTEGRATIONS_HERO_WISE,
  TRANSFERWISE_LOGO,
  ICON_ARROW_CONTROL_LEFT,
  ICON_ARROW_CONTROL_RIGHT,
  ICON_ARROW_CONTROL_LEFT_ROUNDED,
  ICON_ARROW_CONTROL_RIGHT_ROUNDED,
  HUBSTAFF_PEOPLE_BETA_TRANSPARENT,
  SETTINGS_SMART_NOTIFICATIONS_OVERWORKING,
  KEEP_CURRENT_PLAN_ILLUSTRATION,
  SCHEDULED_REPORT_BANNER_ILLUSTRATION,
  TEAMS_PROMOTION_BANNER_ILLUSTRATION,
  CONTRACTOR_COMPLIANCE_BANNER_ILLUSTRATION,
  ACTIVITIES_VIEW_ROUTE_ACTIVE,
  ACTIVITIES_VIEW_ROUTE_INACTIVE,
  ACTIVITIES_VIEW_INFO_ACTIVE,
  ACTIVITIES_VIEW_INFO_INACTIVE,
  ACTIVITIES_SMART_NOTIFICATIONS_BANNER_ILLUSTRATION,
  GETTING_STARTED_TIMESHEET_APPROVED,
  GETTING_STARTED_NO_TEAM_MEMBER_SELECTED,
  GETTING_STARTED_DOWNLOAD_APP_IMG_1,
  GETTING_STARTED_DOWNLOAD_APP_IMG_2,
  GETTING_STARTED_DOWNLOAD_APP_IMG_3,
  INSIGHTS_LOGO,
  INSIGHTS_ACTIVITY_TRACKING_DISABLED,
  INSIGHTS_TOOLS_TRACKING_DISABLED,
  INSIGHTS_TOOLS_TRACKING_UNUSED,
  INSIGHTS_NO_TIME_TRACKED,
  INSIGHTS_INTEGRATION_UNAUTHORIZED,
  INSIGHTS_GITHUB_INTEGRATION_LOGO,
  INSIGHTS_OUTPUT_NO_DATA,
  INSIGHTS_UNUSUAL_ACTIVITIES_CTA,
  INSIGHTS_UNUSUAL_ACTIVITIES_BLURRED_APPS,
  INSIGHTS_UNUSUAL_ACTIVITIES_MEMBERS_TABLE_BLUR_LEFT,
  INSIGHTS_UNUSUAL_ACTIVITIES_MEMBERS_TABLE_BLUR_RIGHT,
  INSIGHTS_COLUMN_CHART_PLACEHOLDER,
  INSIGHTS_DONUT_CHART_PLACEHOLDER,
  INSIGHTS_SHORT_PARAGRAPH_PLACEHOLDER,
  INSIGHTS_MEETINGS_DIALOG_ILLUSTRATION,
  INSIGHTS_MEETINGS_CONNECT,
  INSIGHTS_MEETINGS_GOOGLE_LOGO,
  INSIGHTS_MEETINGS_MICROSOFT365_LOGO,
  INSIGHTS_CANCELLATION_BANNER_ILLUSTRATION_RED,
  INSIGHTS_CANCELLATION_BANNER_ILLUSTRATION_BLUE,
  INSIGHTS_CANCELLATION_BANNER_ILLUSTRATION_30_DAYS,
  INSIGHTS_CANCELLATION_BANNER_ILLUSTRATION_10_PERCENT,
  INSIGHTS_BANNER_UPGRADE,
  INSIGHTS_BANNER_ENABLE,
  INSIGHTS_BANNER_WORKFORCE,
  INSIGHTS_BANNER_SUSPICIOUS_BEHAVIOR,
  INSIGHTS_BANNER_UNUSUAL_ACTIVITY,
  NO_INSIGHTS_UA_BLUR_USER_1,
  NO_INSIGHTS_UA_BLUR_USER_2,
  NO_INSIGHTS_UA_BLUR_USER_3,
  NO_INSIGHTS_UA_BLUR_USER_4,
  NO_INSIGHTS_UA_BLUR_USER_5,
  NO_INSIGHTS_UA_TIME_BLUR,
  INSIGHTS_BANNER_DIALOG_WTE,
  INSIGHTS_BANNER_DIALOG__APP_URLS,
  INSIGHTS_BANNER_DIALOG_HIGHLIGHTS,
  INSIGHTS_BANNER_DIALOG_FOCUS_TIME,
  INSIGHTS_RANKING_BLURRED_ITEMS_4,
  INSIGHTS_RANKING_BLURRED_ITEMS_5,
  INSIGHTS_RANKING_BLURRED_ITEMS_10,
  INSIGHTS_TIMELINE_BLURRED_APPS_URLS,
  INSIGHTS_ONBOARDING_COMPLETED_IMG,
  INSIGHTS_ONBOARDING_WELCOME_IMG,
  VSMB_GETTING_STARTED_IDLE_TIME_ICON,
  VSMB_GETTING_STARTED_MANUAL_TIME_ICON,
  VSMB_GETTING_STARTED_QUICKSTART_VIDEO_IMG,
  VSMB_GETTING_STARTED_SCREENSHOTS_ICON,
  VSMB_GETTING_STARTED_SPEND_TIME_ON_BUSINESS_IMG,
  VSMB_GETTING_STARTED_WELCOME_IMG,
  ICON_WATCH,
  ICON_BELL,
  SETTINGS_SMART_NOTIFICATION_HIGH_ACTIVITY,
  SETTINGS_SMART_NOTIFICATIONS_UNDERWORKING,
  SETTINGS_SMART_NOTIFICATIONS_LOW_ACTIVITY,
  SMART_NOTIFICATIONS_LOW_ACTIVITY,
  SMART_NOTIFICATIONS_LOW_CORE_WORK,
  SMART_NOTIFICATIONS_OVERWORKING,
  SMART_NOTIFICATIONS_SUSPICIOUS_APPS,
  SMART_NOTIFICATIONS_SUSPICIOUSLY_HIGH_ACTIVITY,
  SMART_NOTIFICATIONS_UNDERWORKING,
  SMART_NOTIFICATIONS_UNPRODUCTIVE_WORK,
  SMART_NOTIFICATIONS_SOCIAL_MEDIA_WEBSITES,
  SMART_NOTIFICATIONS_NOT_USING_APPS,
  SMART_NOTIFICATIONS_AI_WEBSITES,
  SMART_NOTIFICATIONS_ENTERTAINMENT_WEBSITES,
  SMART_NOTIFICATIONS_IDLE_TIME,
  SMART_NOTIFICATIONS_MANUAL_TIME,
  ORGANIZATION_ARCHIVE_BANNER_ILLUSTRATION_RED,
  GETTING_STARTED_FREE_TRIAL_INSIGHTS,
  DISCOUNT_OFFER_ILLUSTRATION,
  DISCOUNT_ACCEPTED_ILLUSTRATION,
};
